module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Book.c6673682.woff2";